import { render, staticRenderFns } from "./OrderServiceReport.vue?vue&type=template&id=068c3b0b&"
import script from "./OrderServiceReport.vue?vue&type=script&lang=js&"
export * from "./OrderServiceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports